function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button } from '.';
import { useTranslation } from 'react-i18next';
export function SaveButton(_ref) {
  let {
    onClick,
    disabled = false,
    saveParams = [],
    dataTestid = 'save_button',
    text = 'save',
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Button, _extends({
    type: "submit",
    icon: "save",
    loading: false,
    onClick: () => onClick && onClick(...saveParams),
    "data-testid": dataTestid,
    disabled: disabled
  }, props), t(text));
}